import { useEffect, useState } from 'react';

import { Text, useViewport, type TextVariant } from '@farmersdog/corgi-x';

export interface TitleProps {
  children: string;
  id: string | undefined;
}

export const Title = ({ children, id }: TitleProps) => {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  const viewport = useViewport();
  const isLargeViewport = hasMounted && viewport.lg;
  const titleVariant: TextVariant = isLargeViewport
    ? 'heading-40'
    : 'heading-28';

  return (
    <Text id={id} color="kale-3" variant={titleVariant} as="h2" weight="bold">
      {children}
    </Text>
  );
};
